import { SpatialLayer } from '@innovyze/lib_am_common';
import { createAction } from '@reduxjs/toolkit';

export const changeSpatialProximity = createAction<SpatialLayer | undefined>(
	'spatialProximity/changeDataSource',
);
